module.exports = __webpack_public_path__ + "img/ford-New.15a3612f.png";